module.exports = __webpack_public_path__ + "img/yellow.30358d55.png";